import React, { useState, useEffect } from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Box
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LayoutDashboard from '../layout/LayoutDashboard';
import '../CSS/ListeDeclarations.css';
import apiUrl from '../config';

const ListeDeclarations = () => {

  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {

    const fetchSalaries = async () => {

      try{

        const token = localStorage.getItem('token');

        const response = await axios.get(
          `${apiUrl}/users-declarations`,
          { headers:{ Authorization:`Bearer ${token}` } }
        );

        setSalaries(response.data);

      }catch(error){
        console.error(error);
      }

      setLoading(false);

    };

    fetchSalaries();

  },[]);

  const handleNavigateToDeclarations = (id) => {
  localStorage.setItem("selectedUserId", id);
  navigate("/Déclarations", { state: { selectedUserId: id } }); // ✅ userId → selectedUserId
};

  return (

<LayoutDashboard>

<div className="declarations-page">

{/* HEADER */}

<div className="header">

<Typography variant="h1">
Liste des Déclarations
</Typography>

</div>

{/* TABLE */}

<div className="declarations-table">

{loading ? (

<div className="loading">

<CircularProgress />

<p>Merci de patienter...</p>

</div>

) : (

<TableContainer>

<Table>

<TableHead>

<TableRow>

<TableCell>Nom</TableCell>
<TableCell>Prénom</TableCell>
<TableCell>Email</TableCell>
<TableCell>Déclarations</TableCell>
<TableCell>Statut</TableCell>
<TableCell>Action</TableCell>

</TableRow>

</TableHead>

<TableBody>

{salaries.map((salarie)=>(

<TableRow key={salarie.id}>

<TableCell>{salarie.nom}</TableCell>
<TableCell>{salarie.prenom}</TableCell>
<TableCell>{salarie.email}</TableCell>
<TableCell>{salarie.declarationsCount}</TableCell>

<TableCell>

<span className={
salarie.compte_status === "Compte validé"
? "status-ok"
: "status-bad"
}>

{salarie.compte_status}

</span>

</TableCell>

<TableCell>

<Button
className="action-btn"
onClick={()=>handleNavigateToDeclarations(salarie.id)}
>

Voir Déclarations

</Button>

</TableCell>

</TableRow>

))}

</TableBody>

</Table>

</TableContainer>

)}

</div>

</div>

</LayoutDashboard>

);

};

export default ListeDeclarations;